import { render } from "./Success.vue?vue&type=template&id=130e587c&scoped=true"
const script = {}

import "./Success.vue?vue&type=style&index=0&id=130e587c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130e587c"]])

export default __exports__